import gql from 'graphql-tag';
import { datasetFragment, datasetFragmentName } from './Fragments';
const DatasetQueries = {
  DatasetQuery: gql`
    query getDatasets {
      datasets {
        ...${datasetFragmentName}
      }
    }
    ${datasetFragment}
  `,
  RefreshSugarCrmDatasetMutation: gql`
    mutation refreshSugarCrmDataset($id: String!) {
      refreshSugarCrmDataset(id: $id)
    }
  `,
  GetSugarCrmSchemas: gql`
    query sugarCrmSchemas {
      sugarCrmSchemas {
        datasetId
        modules {
          name
          fields {
            name
            json
          }
          enabled
          visible
        }
        relationships {
          relationshipType
          lhsModule
          rhsModule
          rhsKey
          lhsKey
        }
      }
    }
  `,
  GetSugarCrmDatasetCustomAnnotations: gql`
    query getSugarCrmDatasetAnnotations($id: String!) {
      getSugarCrmDatasetAnnotations(id: $id) {
        datasetJson
        systemName
        objectIdAttrib
        closeDateAttrib
        createdDateAttrib
        success
        errorMessage
      }
    }
  `,
  UpdateSugarCrmDatasetCustomAnnotations: gql`
    mutation updateSugarCrmDatasetAnnotations(
      $request: CustomDatasetAnnotationUpdateRequest!
    ) {
      updateSugarCrmDatasetAnnotations(request: $request) {
        datasetJson
      }
    }
  `,
  DeleteDatasetMutation: gql`
    mutation delete($datasetId: String!) {
      deleteDataset(id: $datasetId) {
        id
      }
    }
  `,
  DatasetDetail: gql`
    query datasetDetail($id: String!) {
      dataset(id: $id) {
        ...${datasetFragmentName}
      }
    }
    ${datasetFragment}
  `,
  DatasetPreviewQuery: gql`
    query datasetPreview(
      $id: String!
      $fields: [String!]!
      $limit: Int
      $useFiscalCalendar: Boolean = false
    ) {
      executeQuery(
        query: {
          datasetId: $id
          attributeNames: $fields
          measures: []
          filters: []
          sorts: []
          limit: $limit
          useFiscalCalendar: $useFiscalCalendar
        }
      ) {
        columnNames
        columnInfo {
          columnName
          attributeName
          columnType
          parentName
          aggregationName
        }
        results
      }
    }
  `,
  CreateSugarCrmDatasetMutation: gql`
    mutation createSugarCrmDataset($request: SugarCrmDatasetRequest!) {
      createSugarCrmDataset(request: $request) {
        id
      }
    }
  `,
  AggregationInfo: gql`
    query getAggregationInfo {
      aggregateInfo {
        name
        supportedTypes
        functionName
        abbreviation
      }
    }
  `,
  CalcFunctionNames: gql`
    query getCalcFunctionNames {
      calcFunctionNames
    }
  `,
  CalcFunctionInfo: gql`
    query getCalcInfo {
      aggregateInfo {
        name
        supportedTypes
        functionName
        abbreviation
      }
      calcFunctionNames
    }
  `,
  UpdateSugarCrmDatasetAuthMutation: gql`
    mutation ($request: SugarCrmDatasetUpdateAuthRequest!) {
      updateSugarCrmAuth(request: $request)
    }
  `,
  GenerateSugarCrmAuthTokensMutation: gql`
    mutation ($request: SugarCrmDatasetGenerateAuthTokensRequest!) {
      generateSugarCrmAuthTokens(request: $request) {
        instanceUrl
        username
        accessToken
        refreshToken
        success
        errorMessage
      }
    }
  `,
  UpdateDataset: gql`
    mutation ($dataset: DatasetRequest!, $removeAttributeIdxs: [Int!]) {
      updateDataset(
        dataset: $dataset
        removeAttributeIdxs: $removeAttributeIdxs
      ) {
        ...${datasetFragmentName}
      }
    }
    ${datasetFragment}
  `,
};
export default DatasetQueries;
